import { useQuery } from "@tanstack/react-query";
import { useApi } from "~hooks/apiHooks/useApi/useApi";
import { useAuth0 } from "@auth0/auth0-react";

export const useGetNewNotificationCount = () => {
  const request = useApi();
  const { isAuthenticated } = useAuth0();

  return useQuery({
    queryKey: ["notifications", "count", "new"],
    queryFn: () => request<{ data: number }>(`notifications/count/new`).then((response) => response?.data || 0),
    staleTime: 0,
    refetchInterval: 30000,
    refetchOnWindowFocus: true,
    enabled: isAuthenticated,
  });
};
